import React from 'react';
import { FaCheck, FaQuestion, FaXmark, FaExclamation } from "react-icons/fa6";
const StatusCellRenderer = ({ value, legend }) => {
    const status = value;
    if (!status) return null;

    const defaultClasses = `${legend ? "h-[18px] w-[18px] text-sm rounded-[3px]" : "h-[25px] w-[25px] rounded-[5px]" } !text-white m-auto flex items-center justify-center`;
    const sizeFa = legend ? 10 : 14;

    switch (status) {
        case 'ONLINE':
            return <span className={`${defaultClasses} bg-[#008a0e]`}><FaCheck size={sizeFa} /></span>;
        case 'WARNING':
        case 'LANE_NOT_CONFIG':
            return <span className={`${defaultClasses} bg-[#fbae1d]`}><FaExclamation size={sizeFa} /></span>;
        case 'OFFLINE':
            return <span className={`${defaultClasses} bg-[#cb0000]`}><FaXmark size={sizeFa} /></span>;
        // case 'LANE_NOT_CONFIG':
        //     return <span className={`${defaultClasses} bg-[#9d9d9f]`}><FaQuestion size={sizeFa} /></span>;
        default:
            return null;
    }
};

export default StatusCellRenderer;
